import type { TimeZone } from "@eroad/types";

const CA_TIMEZONES: TimeZone[] = [
  {
    cities: "Bathurst_Charlottetown_Fredericton_Halifax_Moncton_New Glasgow_Saint John_Summerside_Sydney_Truro".split(
      "_",
    ),
    timeZone: "America/Halifax",
  },
  {
    cities: "Brandon_Dauphin_Flin Flon_Morden_Portage la Prairie_Selkirk_Steinbach_Thompson_Winkler_Winnipeg".split(
      "_",
    ),
    timeZone: "America/Winnipeg",
  },
  {
    cities: "Brampton_Gatineau_Hamilton_London_Mississauga_Montreal_Ottawa_Quebec City_Toronto_Windsor".split("_"),
    timeZone: "America/Toronto",
  },
  {
    cities:
      "Airdrie_Calgary_Edmonton_Grande Prairie_Leduc_Lethbridge_Medicine Hat_Red Deer_Spruce Grove_St. Albert".split(
        "_",
      ),
    timeZone: "America/Edmonton",
  },
  {
    cities: "Abbotsford_Burnaby_Coquitlam_Kamloops_Kelowna_Langley_Nanaimo_Richmond_Surrey_Vancouver".split("_"),
    timeZone: "America/Vancouver",
  },
];

export { CA_TIMEZONES };
